/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SubscribeRouteImport } from './routes/subscribe'
import { Route as SigninRouteImport } from './routes/signin'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as RegisterRouteImport } from './routes/register'
import { Route as OnboardingRouteImport } from './routes/onboarding'
import { Route as CheckoutRouteImport } from './routes/checkout'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as AppRouteImport } from './routes/app'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as IndexRouteImport } from './routes/index'
import { Route as CheckoutIndexRouteImport } from './routes/checkout/index'
import { Route as AppIndexRouteImport } from './routes/app/index'
import { Route as OnboardingPersonalRouteImport } from './routes/onboarding/personal'
import { Route as OnboardingOrgRouteImport } from './routes/onboarding/org'
import { Route as JoinTokenRouteImport } from './routes/join/$token'
import { Route as CheckoutSuccessRouteImport } from './routes/checkout/success'
import { Route as AuthVerifyRouteImport } from './routes/auth/verify'
import { Route as AppSettingsRouteImport } from './routes/app/settings'
import { Route as AppFaqRouteImport } from './routes/app/faq'
import { Route as AdminFirmsRouteImport } from './routes/admin/firms'
import { Route as AppSettingsIndexRouteImport } from './routes/app/settings/index'
import { Route as AppClientsIndexRouteImport } from './routes/app/clients/index'
import { Route as AppSettingsOrganisationRouteImport } from './routes/app/settings/organisation'
import { Route as AppClientsClientIdRouteImport } from './routes/app/clients/$clientId'
import { Route as AppSettingsUserIndexRouteImport } from './routes/app/settings/user/index'
import { Route as AppSettingsOrganisationIndexRouteImport } from './routes/app/settings/organisation/index'
import { Route as AppSettingsUserSupportRouteImport } from './routes/app/settings/user/support'
import { Route as AppSettingsUserSecurityRouteImport } from './routes/app/settings/user/security'
import { Route as AppSettingsUserProfileRouteImport } from './routes/app/settings/user/profile'
import { Route as AppSettingsUserPreferencesRouteImport } from './routes/app/settings/user/preferences'
import { Route as AppSettingsUserInvitationsRouteImport } from './routes/app/settings/user/invitations'
import { Route as AppSettingsOrganisationPermissionsRouteImport } from './routes/app/settings/organisation/permissions'
import { Route as AppSettingsOrganisationNewRouteImport } from './routes/app/settings/organisation/new'
import { Route as AppSettingsOrganisationMembersRouteImport } from './routes/app/settings/organisation/members'
import { Route as AppSettingsOrganisationGeneralRouteImport } from './routes/app/settings/organisation/general'
import { Route as AppSettingsOrganisationEscrowRouteImport } from './routes/app/settings/organisation/escrow'
import { Route as AppSettingsOrganisationBrandingRouteImport } from './routes/app/settings/organisation/branding'
import { Route as AppSettingsOrganisationBillingRouteImport } from './routes/app/settings/organisation/billing'
import { Route as AppSettingsUserSupportIndexRouteImport } from './routes/app/settings/user/support/index'
import { Route as AppSettingsUserSupportNewRouteImport } from './routes/app/settings/user/support/new'
import { Route as AppSettingsUserSupportThreadIdRouteImport } from './routes/app/settings/user/support/$threadId'

const SubscribeRoute = SubscribeRouteImport.update({
  id: '/subscribe',
  path: '/subscribe',
  getParentRoute: () => rootRouteImport,
} as any)
const SigninRoute = SigninRouteImport.update({
  id: '/signin',
  path: '/signin',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const RegisterRoute = RegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingRoute = OnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const CheckoutRoute = CheckoutRouteImport.update({
  id: '/checkout',
  path: '/checkout',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/auth',
  path: '/auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/app',
  path: '/app',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const CheckoutIndexRoute = CheckoutIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => CheckoutRoute,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const OnboardingPersonalRoute = OnboardingPersonalRouteImport.update({
  id: '/personal',
  path: '/personal',
  getParentRoute: () => OnboardingRoute,
} as any)
const OnboardingOrgRoute = OnboardingOrgRouteImport.update({
  id: '/org',
  path: '/org',
  getParentRoute: () => OnboardingRoute,
} as any)
const JoinTokenRoute = JoinTokenRouteImport.update({
  id: '/join/$token',
  path: '/join/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const CheckoutSuccessRoute = CheckoutSuccessRouteImport.update({
  id: '/success',
  path: '/success',
  getParentRoute: () => CheckoutRoute,
} as any)
const AuthVerifyRoute = AuthVerifyRouteImport.update({
  id: '/verify',
  path: '/verify',
  getParentRoute: () => AuthRoute,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any)
const AppFaqRoute = AppFaqRouteImport.update({
  id: '/faq',
  path: '/faq',
  getParentRoute: () => AppRoute,
} as any)
const AdminFirmsRoute = AdminFirmsRouteImport.update({
  id: '/firms',
  path: '/firms',
  getParentRoute: () => AdminRoute,
} as any)
const AppSettingsIndexRoute = AppSettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppClientsIndexRoute = AppClientsIndexRouteImport.update({
  id: '/clients/',
  path: '/clients/',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsOrganisationRoute = AppSettingsOrganisationRouteImport.update({
  id: '/organisation',
  path: '/organisation',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppClientsClientIdRoute = AppClientsClientIdRouteImport.update({
  id: '/clients/$clientId',
  path: '/clients/$clientId',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsUserIndexRoute = AppSettingsUserIndexRouteImport.update({
  id: '/user/',
  path: '/user/',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsOrganisationIndexRoute =
  AppSettingsOrganisationIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppSettingsOrganisationRoute,
  } as any)
const AppSettingsUserSupportRoute = AppSettingsUserSupportRouteImport.update({
  id: '/user/support',
  path: '/user/support',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsUserSecurityRoute = AppSettingsUserSecurityRouteImport.update({
  id: '/user/security',
  path: '/user/security',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsUserProfileRoute = AppSettingsUserProfileRouteImport.update({
  id: '/user/profile',
  path: '/user/profile',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsUserPreferencesRoute =
  AppSettingsUserPreferencesRouteImport.update({
    id: '/user/preferences',
    path: '/user/preferences',
    getParentRoute: () => AppSettingsRoute,
  } as any)
const AppSettingsUserInvitationsRoute =
  AppSettingsUserInvitationsRouteImport.update({
    id: '/user/invitations',
    path: '/user/invitations',
    getParentRoute: () => AppSettingsRoute,
  } as any)
const AppSettingsOrganisationPermissionsRoute =
  AppSettingsOrganisationPermissionsRouteImport.update({
    id: '/permissions',
    path: '/permissions',
    getParentRoute: () => AppSettingsOrganisationRoute,
  } as any)
const AppSettingsOrganisationNewRoute =
  AppSettingsOrganisationNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AppSettingsOrganisationRoute,
  } as any)
const AppSettingsOrganisationMembersRoute =
  AppSettingsOrganisationMembersRouteImport.update({
    id: '/members',
    path: '/members',
    getParentRoute: () => AppSettingsOrganisationRoute,
  } as any)
const AppSettingsOrganisationGeneralRoute =
  AppSettingsOrganisationGeneralRouteImport.update({
    id: '/general',
    path: '/general',
    getParentRoute: () => AppSettingsOrganisationRoute,
  } as any)
const AppSettingsOrganisationEscrowRoute =
  AppSettingsOrganisationEscrowRouteImport.update({
    id: '/escrow',
    path: '/escrow',
    getParentRoute: () => AppSettingsOrganisationRoute,
  } as any)
const AppSettingsOrganisationBrandingRoute =
  AppSettingsOrganisationBrandingRouteImport.update({
    id: '/branding',
    path: '/branding',
    getParentRoute: () => AppSettingsOrganisationRoute,
  } as any)
const AppSettingsOrganisationBillingRoute =
  AppSettingsOrganisationBillingRouteImport.update({
    id: '/billing',
    path: '/billing',
    getParentRoute: () => AppSettingsOrganisationRoute,
  } as any)
const AppSettingsUserSupportIndexRoute =
  AppSettingsUserSupportIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppSettingsUserSupportRoute,
  } as any)
const AppSettingsUserSupportNewRoute =
  AppSettingsUserSupportNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => AppSettingsUserSupportRoute,
  } as any)
const AppSettingsUserSupportThreadIdRoute =
  AppSettingsUserSupportThreadIdRouteImport.update({
    id: '/$threadId',
    path: '/$threadId',
    getParentRoute: () => AppSettingsUserSupportRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteWithChildren
  '/app': typeof AppRouteWithChildren
  '/auth': typeof AuthRouteWithChildren
  '/checkout': typeof CheckoutRouteWithChildren
  '/onboarding': typeof OnboardingRouteWithChildren
  '/register': typeof RegisterRoute
  '/settings': typeof SettingsRoute
  '/signin': typeof SigninRoute
  '/subscribe': typeof SubscribeRoute
  '/admin/firms': typeof AdminFirmsRoute
  '/app/faq': typeof AppFaqRoute
  '/app/settings': typeof AppSettingsRouteWithChildren
  '/auth/verify': typeof AuthVerifyRoute
  '/checkout/success': typeof CheckoutSuccessRoute
  '/join/$token': typeof JoinTokenRoute
  '/onboarding/org': typeof OnboardingOrgRoute
  '/onboarding/personal': typeof OnboardingPersonalRoute
  '/app/': typeof AppIndexRoute
  '/checkout/': typeof CheckoutIndexRoute
  '/app/clients/$clientId': typeof AppClientsClientIdRoute
  '/app/settings/organisation': typeof AppSettingsOrganisationRouteWithChildren
  '/app/clients/': typeof AppClientsIndexRoute
  '/app/settings/': typeof AppSettingsIndexRoute
  '/app/settings/organisation/billing': typeof AppSettingsOrganisationBillingRoute
  '/app/settings/organisation/branding': typeof AppSettingsOrganisationBrandingRoute
  '/app/settings/organisation/escrow': typeof AppSettingsOrganisationEscrowRoute
  '/app/settings/organisation/general': typeof AppSettingsOrganisationGeneralRoute
  '/app/settings/organisation/members': typeof AppSettingsOrganisationMembersRoute
  '/app/settings/organisation/new': typeof AppSettingsOrganisationNewRoute
  '/app/settings/organisation/permissions': typeof AppSettingsOrganisationPermissionsRoute
  '/app/settings/user/invitations': typeof AppSettingsUserInvitationsRoute
  '/app/settings/user/preferences': typeof AppSettingsUserPreferencesRoute
  '/app/settings/user/profile': typeof AppSettingsUserProfileRoute
  '/app/settings/user/security': typeof AppSettingsUserSecurityRoute
  '/app/settings/user/support': typeof AppSettingsUserSupportRouteWithChildren
  '/app/settings/organisation/': typeof AppSettingsOrganisationIndexRoute
  '/app/settings/user/': typeof AppSettingsUserIndexRoute
  '/app/settings/user/support/$threadId': typeof AppSettingsUserSupportThreadIdRoute
  '/app/settings/user/support/new': typeof AppSettingsUserSupportNewRoute
  '/app/settings/user/support/': typeof AppSettingsUserSupportIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteWithChildren
  '/auth': typeof AuthRouteWithChildren
  '/onboarding': typeof OnboardingRouteWithChildren
  '/register': typeof RegisterRoute
  '/settings': typeof SettingsRoute
  '/signin': typeof SigninRoute
  '/subscribe': typeof SubscribeRoute
  '/admin/firms': typeof AdminFirmsRoute
  '/app/faq': typeof AppFaqRoute
  '/auth/verify': typeof AuthVerifyRoute
  '/checkout/success': typeof CheckoutSuccessRoute
  '/join/$token': typeof JoinTokenRoute
  '/onboarding/org': typeof OnboardingOrgRoute
  '/onboarding/personal': typeof OnboardingPersonalRoute
  '/app': typeof AppIndexRoute
  '/checkout': typeof CheckoutIndexRoute
  '/app/clients/$clientId': typeof AppClientsClientIdRoute
  '/app/clients': typeof AppClientsIndexRoute
  '/app/settings': typeof AppSettingsIndexRoute
  '/app/settings/organisation/billing': typeof AppSettingsOrganisationBillingRoute
  '/app/settings/organisation/branding': typeof AppSettingsOrganisationBrandingRoute
  '/app/settings/organisation/escrow': typeof AppSettingsOrganisationEscrowRoute
  '/app/settings/organisation/general': typeof AppSettingsOrganisationGeneralRoute
  '/app/settings/organisation/members': typeof AppSettingsOrganisationMembersRoute
  '/app/settings/organisation/new': typeof AppSettingsOrganisationNewRoute
  '/app/settings/organisation/permissions': typeof AppSettingsOrganisationPermissionsRoute
  '/app/settings/user/invitations': typeof AppSettingsUserInvitationsRoute
  '/app/settings/user/preferences': typeof AppSettingsUserPreferencesRoute
  '/app/settings/user/profile': typeof AppSettingsUserProfileRoute
  '/app/settings/user/security': typeof AppSettingsUserSecurityRoute
  '/app/settings/organisation': typeof AppSettingsOrganisationIndexRoute
  '/app/settings/user': typeof AppSettingsUserIndexRoute
  '/app/settings/user/support/$threadId': typeof AppSettingsUserSupportThreadIdRoute
  '/app/settings/user/support/new': typeof AppSettingsUserSupportNewRoute
  '/app/settings/user/support': typeof AppSettingsUserSupportIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteWithChildren
  '/app': typeof AppRouteWithChildren
  '/auth': typeof AuthRouteWithChildren
  '/checkout': typeof CheckoutRouteWithChildren
  '/onboarding': typeof OnboardingRouteWithChildren
  '/register': typeof RegisterRoute
  '/settings': typeof SettingsRoute
  '/signin': typeof SigninRoute
  '/subscribe': typeof SubscribeRoute
  '/admin/firms': typeof AdminFirmsRoute
  '/app/faq': typeof AppFaqRoute
  '/app/settings': typeof AppSettingsRouteWithChildren
  '/auth/verify': typeof AuthVerifyRoute
  '/checkout/success': typeof CheckoutSuccessRoute
  '/join/$token': typeof JoinTokenRoute
  '/onboarding/org': typeof OnboardingOrgRoute
  '/onboarding/personal': typeof OnboardingPersonalRoute
  '/app/': typeof AppIndexRoute
  '/checkout/': typeof CheckoutIndexRoute
  '/app/clients/$clientId': typeof AppClientsClientIdRoute
  '/app/settings/organisation': typeof AppSettingsOrganisationRouteWithChildren
  '/app/clients/': typeof AppClientsIndexRoute
  '/app/settings/': typeof AppSettingsIndexRoute
  '/app/settings/organisation/billing': typeof AppSettingsOrganisationBillingRoute
  '/app/settings/organisation/branding': typeof AppSettingsOrganisationBrandingRoute
  '/app/settings/organisation/escrow': typeof AppSettingsOrganisationEscrowRoute
  '/app/settings/organisation/general': typeof AppSettingsOrganisationGeneralRoute
  '/app/settings/organisation/members': typeof AppSettingsOrganisationMembersRoute
  '/app/settings/organisation/new': typeof AppSettingsOrganisationNewRoute
  '/app/settings/organisation/permissions': typeof AppSettingsOrganisationPermissionsRoute
  '/app/settings/user/invitations': typeof AppSettingsUserInvitationsRoute
  '/app/settings/user/preferences': typeof AppSettingsUserPreferencesRoute
  '/app/settings/user/profile': typeof AppSettingsUserProfileRoute
  '/app/settings/user/security': typeof AppSettingsUserSecurityRoute
  '/app/settings/user/support': typeof AppSettingsUserSupportRouteWithChildren
  '/app/settings/organisation/': typeof AppSettingsOrganisationIndexRoute
  '/app/settings/user/': typeof AppSettingsUserIndexRoute
  '/app/settings/user/support/$threadId': typeof AppSettingsUserSupportThreadIdRoute
  '/app/settings/user/support/new': typeof AppSettingsUserSupportNewRoute
  '/app/settings/user/support/': typeof AppSettingsUserSupportIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/app'
    | '/auth'
    | '/checkout'
    | '/onboarding'
    | '/register'
    | '/settings'
    | '/signin'
    | '/subscribe'
    | '/admin/firms'
    | '/app/faq'
    | '/app/settings'
    | '/auth/verify'
    | '/checkout/success'
    | '/join/$token'
    | '/onboarding/org'
    | '/onboarding/personal'
    | '/app/'
    | '/checkout/'
    | '/app/clients/$clientId'
    | '/app/settings/organisation'
    | '/app/clients/'
    | '/app/settings/'
    | '/app/settings/organisation/billing'
    | '/app/settings/organisation/branding'
    | '/app/settings/organisation/escrow'
    | '/app/settings/organisation/general'
    | '/app/settings/organisation/members'
    | '/app/settings/organisation/new'
    | '/app/settings/organisation/permissions'
    | '/app/settings/user/invitations'
    | '/app/settings/user/preferences'
    | '/app/settings/user/profile'
    | '/app/settings/user/security'
    | '/app/settings/user/support'
    | '/app/settings/organisation/'
    | '/app/settings/user/'
    | '/app/settings/user/support/$threadId'
    | '/app/settings/user/support/new'
    | '/app/settings/user/support/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/admin'
    | '/auth'
    | '/onboarding'
    | '/register'
    | '/settings'
    | '/signin'
    | '/subscribe'
    | '/admin/firms'
    | '/app/faq'
    | '/auth/verify'
    | '/checkout/success'
    | '/join/$token'
    | '/onboarding/org'
    | '/onboarding/personal'
    | '/app'
    | '/checkout'
    | '/app/clients/$clientId'
    | '/app/clients'
    | '/app/settings'
    | '/app/settings/organisation/billing'
    | '/app/settings/organisation/branding'
    | '/app/settings/organisation/escrow'
    | '/app/settings/organisation/general'
    | '/app/settings/organisation/members'
    | '/app/settings/organisation/new'
    | '/app/settings/organisation/permissions'
    | '/app/settings/user/invitations'
    | '/app/settings/user/preferences'
    | '/app/settings/user/profile'
    | '/app/settings/user/security'
    | '/app/settings/organisation'
    | '/app/settings/user'
    | '/app/settings/user/support/$threadId'
    | '/app/settings/user/support/new'
    | '/app/settings/user/support'
  id:
    | '__root__'
    | '/'
    | '/admin'
    | '/app'
    | '/auth'
    | '/checkout'
    | '/onboarding'
    | '/register'
    | '/settings'
    | '/signin'
    | '/subscribe'
    | '/admin/firms'
    | '/app/faq'
    | '/app/settings'
    | '/auth/verify'
    | '/checkout/success'
    | '/join/$token'
    | '/onboarding/org'
    | '/onboarding/personal'
    | '/app/'
    | '/checkout/'
    | '/app/clients/$clientId'
    | '/app/settings/organisation'
    | '/app/clients/'
    | '/app/settings/'
    | '/app/settings/organisation/billing'
    | '/app/settings/organisation/branding'
    | '/app/settings/organisation/escrow'
    | '/app/settings/organisation/general'
    | '/app/settings/organisation/members'
    | '/app/settings/organisation/new'
    | '/app/settings/organisation/permissions'
    | '/app/settings/user/invitations'
    | '/app/settings/user/preferences'
    | '/app/settings/user/profile'
    | '/app/settings/user/security'
    | '/app/settings/user/support'
    | '/app/settings/organisation/'
    | '/app/settings/user/'
    | '/app/settings/user/support/$threadId'
    | '/app/settings/user/support/new'
    | '/app/settings/user/support/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRoute: typeof AdminRouteWithChildren
  AppRoute: typeof AppRouteWithChildren
  AuthRoute: typeof AuthRouteWithChildren
  CheckoutRoute: typeof CheckoutRouteWithChildren
  OnboardingRoute: typeof OnboardingRouteWithChildren
  RegisterRoute: typeof RegisterRoute
  SettingsRoute: typeof SettingsRoute
  SigninRoute: typeof SigninRoute
  SubscribeRoute: typeof SubscribeRoute
  JoinTokenRoute: typeof JoinTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/subscribe': {
      id: '/subscribe'
      path: '/subscribe'
      fullPath: '/subscribe'
      preLoaderRoute: typeof SubscribeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/signin': {
      id: '/signin'
      path: '/signin'
      fullPath: '/signin'
      preLoaderRoute: typeof SigninRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/register': {
      id: '/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof RegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding': {
      id: '/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/checkout': {
      id: '/checkout'
      path: '/checkout'
      fullPath: '/checkout'
      preLoaderRoute: typeof CheckoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth': {
      id: '/auth'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app': {
      id: '/app'
      path: '/app'
      fullPath: '/app'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/checkout/': {
      id: '/checkout/'
      path: '/'
      fullPath: '/checkout/'
      preLoaderRoute: typeof CheckoutIndexRouteImport
      parentRoute: typeof CheckoutRoute
    }
    '/app/': {
      id: '/app/'
      path: '/'
      fullPath: '/app/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/onboarding/personal': {
      id: '/onboarding/personal'
      path: '/personal'
      fullPath: '/onboarding/personal'
      preLoaderRoute: typeof OnboardingPersonalRouteImport
      parentRoute: typeof OnboardingRoute
    }
    '/onboarding/org': {
      id: '/onboarding/org'
      path: '/org'
      fullPath: '/onboarding/org'
      preLoaderRoute: typeof OnboardingOrgRouteImport
      parentRoute: typeof OnboardingRoute
    }
    '/join/$token': {
      id: '/join/$token'
      path: '/join/$token'
      fullPath: '/join/$token'
      preLoaderRoute: typeof JoinTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/checkout/success': {
      id: '/checkout/success'
      path: '/success'
      fullPath: '/checkout/success'
      preLoaderRoute: typeof CheckoutSuccessRouteImport
      parentRoute: typeof CheckoutRoute
    }
    '/auth/verify': {
      id: '/auth/verify'
      path: '/verify'
      fullPath: '/auth/verify'
      preLoaderRoute: typeof AuthVerifyRouteImport
      parentRoute: typeof AuthRoute
    }
    '/app/settings': {
      id: '/app/settings'
      path: '/settings'
      fullPath: '/app/settings'
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/faq': {
      id: '/app/faq'
      path: '/faq'
      fullPath: '/app/faq'
      preLoaderRoute: typeof AppFaqRouteImport
      parentRoute: typeof AppRoute
    }
    '/admin/firms': {
      id: '/admin/firms'
      path: '/firms'
      fullPath: '/admin/firms'
      preLoaderRoute: typeof AdminFirmsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/app/settings/': {
      id: '/app/settings/'
      path: '/'
      fullPath: '/app/settings/'
      preLoaderRoute: typeof AppSettingsIndexRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/app/clients/': {
      id: '/app/clients/'
      path: '/clients'
      fullPath: '/app/clients/'
      preLoaderRoute: typeof AppClientsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/settings/organisation': {
      id: '/app/settings/organisation'
      path: '/organisation'
      fullPath: '/app/settings/organisation'
      preLoaderRoute: typeof AppSettingsOrganisationRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/app/clients/$clientId': {
      id: '/app/clients/$clientId'
      path: '/clients/$clientId'
      fullPath: '/app/clients/$clientId'
      preLoaderRoute: typeof AppClientsClientIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/app/settings/user/': {
      id: '/app/settings/user/'
      path: '/user'
      fullPath: '/app/settings/user/'
      preLoaderRoute: typeof AppSettingsUserIndexRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/app/settings/organisation/': {
      id: '/app/settings/organisation/'
      path: '/'
      fullPath: '/app/settings/organisation/'
      preLoaderRoute: typeof AppSettingsOrganisationIndexRouteImport
      parentRoute: typeof AppSettingsOrganisationRoute
    }
    '/app/settings/user/support': {
      id: '/app/settings/user/support'
      path: '/user/support'
      fullPath: '/app/settings/user/support'
      preLoaderRoute: typeof AppSettingsUserSupportRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/app/settings/user/security': {
      id: '/app/settings/user/security'
      path: '/user/security'
      fullPath: '/app/settings/user/security'
      preLoaderRoute: typeof AppSettingsUserSecurityRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/app/settings/user/profile': {
      id: '/app/settings/user/profile'
      path: '/user/profile'
      fullPath: '/app/settings/user/profile'
      preLoaderRoute: typeof AppSettingsUserProfileRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/app/settings/user/preferences': {
      id: '/app/settings/user/preferences'
      path: '/user/preferences'
      fullPath: '/app/settings/user/preferences'
      preLoaderRoute: typeof AppSettingsUserPreferencesRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/app/settings/user/invitations': {
      id: '/app/settings/user/invitations'
      path: '/user/invitations'
      fullPath: '/app/settings/user/invitations'
      preLoaderRoute: typeof AppSettingsUserInvitationsRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/app/settings/organisation/permissions': {
      id: '/app/settings/organisation/permissions'
      path: '/permissions'
      fullPath: '/app/settings/organisation/permissions'
      preLoaderRoute: typeof AppSettingsOrganisationPermissionsRouteImport
      parentRoute: typeof AppSettingsOrganisationRoute
    }
    '/app/settings/organisation/new': {
      id: '/app/settings/organisation/new'
      path: '/new'
      fullPath: '/app/settings/organisation/new'
      preLoaderRoute: typeof AppSettingsOrganisationNewRouteImport
      parentRoute: typeof AppSettingsOrganisationRoute
    }
    '/app/settings/organisation/members': {
      id: '/app/settings/organisation/members'
      path: '/members'
      fullPath: '/app/settings/organisation/members'
      preLoaderRoute: typeof AppSettingsOrganisationMembersRouteImport
      parentRoute: typeof AppSettingsOrganisationRoute
    }
    '/app/settings/organisation/general': {
      id: '/app/settings/organisation/general'
      path: '/general'
      fullPath: '/app/settings/organisation/general'
      preLoaderRoute: typeof AppSettingsOrganisationGeneralRouteImport
      parentRoute: typeof AppSettingsOrganisationRoute
    }
    '/app/settings/organisation/escrow': {
      id: '/app/settings/organisation/escrow'
      path: '/escrow'
      fullPath: '/app/settings/organisation/escrow'
      preLoaderRoute: typeof AppSettingsOrganisationEscrowRouteImport
      parentRoute: typeof AppSettingsOrganisationRoute
    }
    '/app/settings/organisation/branding': {
      id: '/app/settings/organisation/branding'
      path: '/branding'
      fullPath: '/app/settings/organisation/branding'
      preLoaderRoute: typeof AppSettingsOrganisationBrandingRouteImport
      parentRoute: typeof AppSettingsOrganisationRoute
    }
    '/app/settings/organisation/billing': {
      id: '/app/settings/organisation/billing'
      path: '/billing'
      fullPath: '/app/settings/organisation/billing'
      preLoaderRoute: typeof AppSettingsOrganisationBillingRouteImport
      parentRoute: typeof AppSettingsOrganisationRoute
    }
    '/app/settings/user/support/': {
      id: '/app/settings/user/support/'
      path: '/'
      fullPath: '/app/settings/user/support/'
      preLoaderRoute: typeof AppSettingsUserSupportIndexRouteImport
      parentRoute: typeof AppSettingsUserSupportRoute
    }
    '/app/settings/user/support/new': {
      id: '/app/settings/user/support/new'
      path: '/new'
      fullPath: '/app/settings/user/support/new'
      preLoaderRoute: typeof AppSettingsUserSupportNewRouteImport
      parentRoute: typeof AppSettingsUserSupportRoute
    }
    '/app/settings/user/support/$threadId': {
      id: '/app/settings/user/support/$threadId'
      path: '/$threadId'
      fullPath: '/app/settings/user/support/$threadId'
      preLoaderRoute: typeof AppSettingsUserSupportThreadIdRouteImport
      parentRoute: typeof AppSettingsUserSupportRoute
    }
  }
}

interface AdminRouteChildren {
  AdminFirmsRoute: typeof AdminFirmsRoute
}

const AdminRouteChildren: AdminRouteChildren = {
  AdminFirmsRoute: AdminFirmsRoute,
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

interface AppSettingsOrganisationRouteChildren {
  AppSettingsOrganisationBillingRoute: typeof AppSettingsOrganisationBillingRoute
  AppSettingsOrganisationBrandingRoute: typeof AppSettingsOrganisationBrandingRoute
  AppSettingsOrganisationEscrowRoute: typeof AppSettingsOrganisationEscrowRoute
  AppSettingsOrganisationGeneralRoute: typeof AppSettingsOrganisationGeneralRoute
  AppSettingsOrganisationMembersRoute: typeof AppSettingsOrganisationMembersRoute
  AppSettingsOrganisationNewRoute: typeof AppSettingsOrganisationNewRoute
  AppSettingsOrganisationPermissionsRoute: typeof AppSettingsOrganisationPermissionsRoute
  AppSettingsOrganisationIndexRoute: typeof AppSettingsOrganisationIndexRoute
}

const AppSettingsOrganisationRouteChildren: AppSettingsOrganisationRouteChildren =
  {
    AppSettingsOrganisationBillingRoute: AppSettingsOrganisationBillingRoute,
    AppSettingsOrganisationBrandingRoute: AppSettingsOrganisationBrandingRoute,
    AppSettingsOrganisationEscrowRoute: AppSettingsOrganisationEscrowRoute,
    AppSettingsOrganisationGeneralRoute: AppSettingsOrganisationGeneralRoute,
    AppSettingsOrganisationMembersRoute: AppSettingsOrganisationMembersRoute,
    AppSettingsOrganisationNewRoute: AppSettingsOrganisationNewRoute,
    AppSettingsOrganisationPermissionsRoute:
      AppSettingsOrganisationPermissionsRoute,
    AppSettingsOrganisationIndexRoute: AppSettingsOrganisationIndexRoute,
  }

const AppSettingsOrganisationRouteWithChildren =
  AppSettingsOrganisationRoute._addFileChildren(
    AppSettingsOrganisationRouteChildren,
  )

interface AppSettingsUserSupportRouteChildren {
  AppSettingsUserSupportThreadIdRoute: typeof AppSettingsUserSupportThreadIdRoute
  AppSettingsUserSupportNewRoute: typeof AppSettingsUserSupportNewRoute
  AppSettingsUserSupportIndexRoute: typeof AppSettingsUserSupportIndexRoute
}

const AppSettingsUserSupportRouteChildren: AppSettingsUserSupportRouteChildren =
  {
    AppSettingsUserSupportThreadIdRoute: AppSettingsUserSupportThreadIdRoute,
    AppSettingsUserSupportNewRoute: AppSettingsUserSupportNewRoute,
    AppSettingsUserSupportIndexRoute: AppSettingsUserSupportIndexRoute,
  }

const AppSettingsUserSupportRouteWithChildren =
  AppSettingsUserSupportRoute._addFileChildren(
    AppSettingsUserSupportRouteChildren,
  )

interface AppSettingsRouteChildren {
  AppSettingsOrganisationRoute: typeof AppSettingsOrganisationRouteWithChildren
  AppSettingsIndexRoute: typeof AppSettingsIndexRoute
  AppSettingsUserInvitationsRoute: typeof AppSettingsUserInvitationsRoute
  AppSettingsUserPreferencesRoute: typeof AppSettingsUserPreferencesRoute
  AppSettingsUserProfileRoute: typeof AppSettingsUserProfileRoute
  AppSettingsUserSecurityRoute: typeof AppSettingsUserSecurityRoute
  AppSettingsUserSupportRoute: typeof AppSettingsUserSupportRouteWithChildren
  AppSettingsUserIndexRoute: typeof AppSettingsUserIndexRoute
}

const AppSettingsRouteChildren: AppSettingsRouteChildren = {
  AppSettingsOrganisationRoute: AppSettingsOrganisationRouteWithChildren,
  AppSettingsIndexRoute: AppSettingsIndexRoute,
  AppSettingsUserInvitationsRoute: AppSettingsUserInvitationsRoute,
  AppSettingsUserPreferencesRoute: AppSettingsUserPreferencesRoute,
  AppSettingsUserProfileRoute: AppSettingsUserProfileRoute,
  AppSettingsUserSecurityRoute: AppSettingsUserSecurityRoute,
  AppSettingsUserSupportRoute: AppSettingsUserSupportRouteWithChildren,
  AppSettingsUserIndexRoute: AppSettingsUserIndexRoute,
}

const AppSettingsRouteWithChildren = AppSettingsRoute._addFileChildren(
  AppSettingsRouteChildren,
)

interface AppRouteChildren {
  AppFaqRoute: typeof AppFaqRoute
  AppSettingsRoute: typeof AppSettingsRouteWithChildren
  AppIndexRoute: typeof AppIndexRoute
  AppClientsClientIdRoute: typeof AppClientsClientIdRoute
  AppClientsIndexRoute: typeof AppClientsIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppFaqRoute: AppFaqRoute,
  AppSettingsRoute: AppSettingsRouteWithChildren,
  AppIndexRoute: AppIndexRoute,
  AppClientsClientIdRoute: AppClientsClientIdRoute,
  AppClientsIndexRoute: AppClientsIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

interface AuthRouteChildren {
  AuthVerifyRoute: typeof AuthVerifyRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthVerifyRoute: AuthVerifyRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

interface CheckoutRouteChildren {
  CheckoutSuccessRoute: typeof CheckoutSuccessRoute
  CheckoutIndexRoute: typeof CheckoutIndexRoute
}

const CheckoutRouteChildren: CheckoutRouteChildren = {
  CheckoutSuccessRoute: CheckoutSuccessRoute,
  CheckoutIndexRoute: CheckoutIndexRoute,
}

const CheckoutRouteWithChildren = CheckoutRoute._addFileChildren(
  CheckoutRouteChildren,
)

interface OnboardingRouteChildren {
  OnboardingOrgRoute: typeof OnboardingOrgRoute
  OnboardingPersonalRoute: typeof OnboardingPersonalRoute
}

const OnboardingRouteChildren: OnboardingRouteChildren = {
  OnboardingOrgRoute: OnboardingOrgRoute,
  OnboardingPersonalRoute: OnboardingPersonalRoute,
}

const OnboardingRouteWithChildren = OnboardingRoute._addFileChildren(
  OnboardingRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRoute: AdminRouteWithChildren,
  AppRoute: AppRouteWithChildren,
  AuthRoute: AuthRouteWithChildren,
  CheckoutRoute: CheckoutRouteWithChildren,
  OnboardingRoute: OnboardingRouteWithChildren,
  RegisterRoute: RegisterRoute,
  SettingsRoute: SettingsRoute,
  SigninRoute: SigninRoute,
  SubscribeRoute: SubscribeRoute,
  JoinTokenRoute: JoinTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
